import { createAsyncThunk } from '@reduxjs/toolkit';
import { moveFile } from './file';
import { addMovingFiles, updateMovingFileStatus } from './../index';

export const moveFiles = createAsyncThunk('files/moveFiles', async (initialData, { dispatch }) => {
  const { files, destination, isUndo = false } = initialData;

  const movingFilesData = files.map((file) => ({
    id: file.id,
    fileName: file.name,
    status: 'pending',
    oldParent: file?.parent_file || null,
    newParent: destination || null,
  }));

  dispatch(addMovingFiles(movingFilesData));

  const movePromises = movingFilesData.map(async (file) => {
    try {
      await dispatch(
        moveFile({
          id: file.id,
          isUndo,
          ...(destination?.id && destination.id !== 'user-files' && { new_parent: destination.id }),
        })
      ).unwrap();
      dispatch(updateMovingFileStatus({ id: file.id, status: 'fulfilled' }));
    } catch {
      dispatch(updateMovingFileStatus({ id: file.id, status: 'rejected' }));
    }
  });

  await Promise.allSettled(movePromises);
});
